import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BannerImg from "../../../images/locationgcc/sa/web-sa/shape-future.webp";

function Banner(props) {
  return (
    <div
      className="revolution_gcc p-100"
      style={{
        backgroundImage: `url(${BannerImg})`,
        backgroundPosition: "left",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={12} xl={6} xxl={6} className="ms-auto">
            <h2>
              Shape the Future of Your Business with TekRevol’s Web Development
              Services
            </h2>
            <p>
              We enable businesses to elevate their digital presence with our
              web development services. As a pioneering website development
              agency, we specialize in creating impactful online experiences
              customized to your brand. Our team of experts in Saudi Arabia
              delivers top-notch solutions that drive growth and innovation.
              That’s how we ensure your business remains ahead of the
              competition.
            </p>
            <p>
              So, consult with a trusted web development company in Saudi Arabia
              to shape the future of your business. With our proven track record
              of success and commitment to excellence, we empower businesses to
              thrive in the digital landscape. Leverage the power of our
              expertise and industry-leading solutions to unlock new
              opportunities and achieve your business goals.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
